if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql = window.matchMedia('(min-width: 750px)');

        if (!this.elements.viewer || !this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );

        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          const button = mediaToSwitch.querySelector('button');
          if (!button) return;

          button.addEventListener(
            'click',
            this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false)
          );
        });

        if (this.dataset.desktopLayout?.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }
      }

      onSlideChanged(event) {
        const currentElement =
          event?.detail?.currentElement ||
          event?.target?.querySelector?.('[data-media-id].is-active') ||
          event?.target?.querySelector?.('[data-media-id]') ||
          this.elements.viewer?.querySelector?.('[data-media-id].is-active') ||
          this.elements.viewer?.querySelector?.('[data-media-id]');

        const mediaId = currentElement?.dataset?.mediaId;

        if (!mediaId) {
          console.warn('[Me+Lia media-gallery] slideChanged fired without a current media element:', event);
          return;
        }

        const thumbnail = this.elements.thumbnails?.querySelector(`[data-target="${mediaId}"]`);

        if (!thumbnail) {
          console.warn('[Me+Lia media-gallery] No thumbnail found for media ID:', mediaId);
          return;
        }

        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        if (!this.elements.viewer || !mediaId) return;

        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');

        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });

        activeMedia.classList.add('is-active');

        if (prepend) {
          if (activeMedia.parentElement && activeMedia.parentElement.firstChild !== activeMedia) {
            activeMedia.parentElement.prepend(activeMedia);
          }

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);

            if (
              activeThumbnail &&
              activeThumbnail.parentElement &&
              activeThumbnail.parentElement.firstChild !== activeThumbnail
            ) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          if (this.elements.viewer.slider) {
            this.elements.viewer.resetPages();
          }
        }

        this.preventStickyHeader();

        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement?.scrollTo?.({ left: activeMedia.offsetLeft });
          }

          const activeMediaRect = activeMedia.getBoundingClientRect();

          if (activeMediaRect.top > -0.5) return;

          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;

        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);

        this.setActiveThumbnail(activeThumbnail);

        if (activeThumbnail?.dataset?.mediaPosition) {
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));

        const thumbnailButton = thumbnail.querySelector('button');
        if (thumbnailButton) {
          thumbnailButton.setAttribute('aria-current', true);
        }

        if (
          typeof this.elements.thumbnails.isSlideVisible === 'function' &&
          this.elements.thumbnails.isSlideVisible(thumbnail, 10)
        ) {
          return;
        }

        if (this.elements.thumbnails.slider) {
          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
        }
      }

      announceLiveRegion(activeItem, position) {
        if (!this.elements.liveRegion) return;

        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);

          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };

        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        if (typeof window.pauseAllMedia === 'function') {
          window.pauseAllMedia();
        }

        const deferredMedia = activeItem.querySelector('.deferred-media');

        if (deferredMedia && typeof deferredMedia.loadContent === 'function') {
          deferredMedia.loadContent(false);
        }
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');

        if (!this.stickyHeader) return;

        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer?.slider) return;

        this.elements.viewer.slider.setAttribute('role', 'presentation');

        this.elements.viewer.sliderItems?.forEach((slide) => {
          slide.setAttribute('role', 'presentation');
        });
      }
    }
  );
}

/* ==========================================================
   Me + Lia - Product Modal Touch Gestures v2
   Swipe down to dismiss. Swipe left/right to navigate
   between images (scrolls vertically to next/prev).
   X close button always visible in top-right corner.
   ========================================================== */
(function () {
  var SWIPE_X_MIN   = 40;
  var SWIPE_Y_DOWN  = 60;
  var SWIPE_Y_MAX   = 35;
  var DISMISS_ANGLE = 0.55;

  function getContent(modal) {
    return modal.querySelector('.product-media-modal__content');
  }

  function getSlides(modal) {
    var content = getContent(modal);
    if (!content) return [];
    return Array.from(content.children).filter(function (el) {
      return el.tagName === 'IMG' || el.tagName === 'DEFERRED-MEDIA';
    });
  }

  function currentIndex(modal) {
    var content = getContent(modal);
    var slides  = getSlides(modal);
    if (!slides.length || !content) return 0;
    var st = content.scrollTop;
    var best = 0, bestDist = Infinity;
    slides.forEach(function (s, i) {
      var d = Math.abs(s.offsetTop - st);
      if (d < bestDist) { bestDist = d; best = i; }
    });
    return best;
  }

  function goTo(modal, index) {
    var content = getContent(modal);
    var slides  = getSlides(modal);
    if (!content || !slides.length) return;
    var i = Math.max(0, Math.min(index, slides.length - 1));
    content.scrollTo({ top: slides[i].offsetTop, behavior: 'smooth' });
  }

  function dismiss(modal) {
    var btn = modal.querySelector('.product-media-modal__toggle');
    if (btn) { btn.click(); } else { modal.removeAttribute('open'); }
  }

  function attachSwipe(modal) {
    if (modal.__mlSwipeBound) return;
    modal.__mlSwipeBound = true;

    var startX = 0, startY = 0, tracking = false;

    function onStart(e) {
      if (e.touches.length !== 1) { tracking = false; return; }
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      tracking = true;
    }

    function onEnd(e) {
      if (!tracking) return;
      tracking = false;
      var t   = e.changedTouches[0];
      var dx  = t.clientX - startX;
      var dy  = t.clientY - startY;
      var adx = Math.abs(dx);
      var ady = Math.abs(dy);

      // Swipe DOWN to dismiss
      if (dy > SWIPE_Y_DOWN && ady > adx * DISMISS_ANGLE) {
        dismiss(modal);
        return;
      }

      // Swipe LEFT or RIGHT to navigate
      if (adx >= SWIPE_X_MIN && ady <= SWIPE_Y_MAX) {
        var slides = getSlides(modal);
        if (slides.length <= 1) return;
        var cur = currentIndex(modal);
        goTo(modal, dx < 0 ? cur + 1 : cur - 1);
      }
    }

    modal.addEventListener('touchstart', onStart, { passive: true });
    modal.addEventListener('touchend',   onEnd,   { passive: true });

    var obs = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.attributeName === 'open' && !modal.hasAttribute('open')) {
          modal.removeEventListener('touchstart', onStart);
          modal.removeEventListener('touchend',   onEnd);
          modal.__mlSwipeBound = false;
          obs.disconnect();
        }
      });
    });
    obs.observe(modal, { attributes: true });
  }

  function watchForModals() {
    var obs = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.type === 'attributes' && m.attributeName === 'open') {
          var el = m.target;
          if (el.matches && el.matches('product-modal') && el.hasAttribute('open')) {
            attachSwipe(el);
          }
        }
        if (m.type === 'childList') {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            var list = node.matches && node.matches('product-modal')
              ? [node]
              : Array.from(node.querySelectorAll ? node.querySelectorAll('product-modal') : []);
            list.forEach(function (pm) {
              if (pm.hasAttribute('open')) attachSwipe(pm);
            });
          });
        }
      });
    });
    obs.observe(document.body, {
      subtree: true, childList: true,
      attributes: true, attributeFilter: ['open']
    });
    document.querySelectorAll('product-modal[open]').forEach(attachSwipe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchForModals);
  } else {
    watchForModals();
  }
})();
